import React from 'react';
import { publicSiteUrl } from 'src/common';
import { VodapayLogoV2, VodapayLogoWithTextV2 } from 'src/assets/images';
import TealiumEvents from 'src/helpers/tealium-events';
import MiniAppEvents from 'src/helpers/miniapp-events';
import { PublicSiteLayout } from 'src/components/public-site-layout/public-site-layout';
import './self-service-form-background.scss';

type Props = {
  children: React.ReactNode;
  className: string;
};
export function SelfServiceFormBackground({ children, className }: Props) {
  const inMiniProgram = MiniAppEvents.isInMiniApp();
  const backLink = () => (
    <div className="has-text-left back-link">
      {!inMiniProgram && (
        <a
          onClick={() => {
            TealiumEvents.userClicksLogin('Back to vodacom.co.za');
            window.location.href = publicSiteUrl;
          }}
          automationid="Self_Service_Span_Link_Back_To_Vodacom"
        >
          <span className="icon-menu-chevron-left has-padding-right-6 is-size-7" />
          Back to vodacom.co.za
        </a>
      )}
    </div>
  );

  const contentLeft = (
    <div className="columns full-height is-vcentered">
      <div className="is-offset-2 column is-8">
        <img src={VodapayLogoWithTextV2} alt="Vodapay logo" />
        <p className="titleText has-padding-top-3">
          Sign up for a VodaPay device and make accepting payments easier
        </p>
        <p className="subtext has-padding-top-4">Fast, safe and easy payments</p>
        {backLink()}
      </div>
    </div>
  );

  const contentRight = (
    <>
      <img className="mobileLogo" src={VodapayLogoV2} alt="Vodacom logo" />
      {children}
      <div className="mobile-only">{backLink()}</div>
    </>
  );

  return (
    <div className="SelfServiceFormBackground">
      <PublicSiteLayout
        className={className}
        contentLeft={contentLeft}
        contentRight={contentRight}
      />
    </div>
  );
}
